import { Outlet } from 'react-router-dom';
import { AppShell, Box, Flex, useMantineTheme } from '@mantine/core';
import AppFooter from '@/components/AppFooter';
import PublicHeader from '@/components/PublicHeader';
import SkipLink from '@/components/SkipLink';
import { headerClass } from '@/components/header/HeaderShell';

// Публичная оболочка: закреплённая шапка (общая с кабинетом) + scrollable Main.
// Sticky-footer: контент растягивается (flex-grow), футер прижат к низу — без жёстких высот,
// поэтому корректно скроллится при любой высоте окна и на мобильном.
export default function PublicLayout() {
  const { headerHeight } = useMantineTheme().other;
  return (
    <AppShell header={{ height: headerHeight }} padding={0}>
      <SkipLink />
      <AppShell.Header withBorder={false} className={headerClass}>
        <PublicHeader />
      </AppShell.Header>

      <AppShell.Main id="main" tabIndex={-1}>
        <Flex direction="column" mih={`calc(100dvh - ${headerHeight}px)`}>
          <Box style={{ flexGrow: 1 }}>
            <Outlet />
          </Box>
          <AppFooter />
        </Flex>
      </AppShell.Main>
    </AppShell>
  );
}
